// src/hooks/useAuditorias.js
import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/api';

const AUDIT_KEY = 'auditorias';

export const useAuditorias = (filters = {}) => {
    return useQuery({
        queryKey: [AUDIT_KEY, 'lista', filters],
        queryFn: async () => {
            const { data } = await apiClient.get('/auditorias', { params: filters });
            return {
                data: data.data || [],
                count: data.count || 0,
                pagination: data.pagination || {},
            };
        },
        staleTime: 1000 * 30,
    });
};

export const useAuditoriaById = (id) => {
    return useQuery({
        queryKey: [AUDIT_KEY, 'detalhe', id],
        queryFn: async () => {
            const { data } = await apiClient.get(`/auditorias/${id}`);
            return data.data || null;
        },
        enabled: !!id,
        staleTime: 1000 * 60,
    });
};

export const useAuditoriasByUser = (userId) => {
    return useQuery({
        queryKey: [AUDIT_KEY, 'user', userId],
        queryFn: async () => {
            const { data } = await apiClient.get(`/auditorias/user/${userId}`);
            return data.data || [];
        },
        enabled: !!userId,
        staleTime: 1000 * 30,
    });
};

export const useAuditoriasByAccount = (accountId) => {
    return useQuery({
        queryKey: [AUDIT_KEY, 'account', accountId],
        queryFn: async () => {
            const { data } = await apiClient.get(`/auditorias/account/${accountId}`);
            return data.data || [];
        },
        enabled: !!accountId,
        staleTime: 1000 * 30,
    });
};
